import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary'
import { ModalWrapper, Modal } from '@gluedigital/modal'
import CapacitorHack from 'src/components/CapacitorHack'
import Meta from 'src/components/Meta'
import PublicRoutes from './PublicRoutes'
import PrivateRoutes from './PrivateRoutes'
import Analytics from 'src/components/Analytics'

declare const __CLIENT__: boolean

const App = () => {
  const dispatch = useDispatch()

  const isLoggedIn = useSelector((s) => s.user && !!s.user.token)

  useEffect(() => {
    // Special action so we know that we just finished rendering
    dispatch({ type: '@@_AFTER_RENDER' })
  }, [dispatch])

  return (
    <ModalWrapper>
      <Meta />
      {__CLIENT__ ? <Analytics /> : null}
      {__CLIENT__ && <CapacitorHack />}
      <main id="app">
        <ErrorBoundary>
          {isLoggedIn ? <PrivateRoutes /> : <PublicRoutes />}
        </ErrorBoundary>
        <Modal />
      </main>
    </ModalWrapper>
  )
}

export default App
